import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[appAutofocus]',
})
export class AutofocusDirective implements AfterViewInit {
  private readonly _element = inject<ElementRef<HTMLInputElement>>(ElementRef);

  public ngAfterViewInit(): void {
    setTimeout(() => this._element.nativeElement.focus(), 150);
  }
}
